export const ROSTER_ACTION_RESTRICTED_TOOLTIP =
  'This action is currently restricted. Please contact SEAA for details.';
